module.exports = __webpack_public_path__ + "static/media/tab-invoices-icon.373d1c91.png";